import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import { Helmet } from 'react-helmet';

import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import WebIcon from '@material-ui/icons/Web';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import { getLocation } from '../../shared/requests/LocationRequests';
import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import profilePlaceholder from '../../static/img/profile_placeholder.png';
import { GOOGLE_MAPS_NAV_LINK } from '../../shared/Constants';
import { createProfileRoute } from '../../shared/Helpers';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  loadingSpinner: {
    margin: theme.spacing(5),
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up(800 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
    },
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(4))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  gridPadding: {
    padding: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(),
    marginRight: theme.spacing(),
  },
  classTypeIcon: {
    padding: theme.spacing(2.5),
    width: '100%',
  },
  link: {
    textDecoration: 'none',
    textTransform: 'uppercase',
  },
  timezoneNote: {
    paddingTop: theme.spacing(0.5),
    fontSize: 12,
  },
  heading: {
    color: theme.palette.text.secondary,
    letterSpacing: 2,
    textTransform: 'uppercase',
    padding: theme.spacing(),
  },
  classImg: {
    marginTop: theme.spacing(),
    width: 'auto',
    height: '200px',
    borderRadius: '10px',
    margin: '0 auto',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  subHeader: {
    fontSize: 18,
    marginBottom: theme.spacing(),
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  classTypeHeader: {
    fontWeight: 400,
    fontSize: 32,
    letterSpacing: '1px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textTransform: 'uppercase',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  borderRight: {
    [theme.breakpoints.up(600)]: {
      borderRight: '1px solid rgba(0, 0, 0, 0.2)',
    },
  },
  h3: {
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    fontSize: 14,
    marginBottom: theme.spacing(),
  },
  sectionContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  iconButton: {
  },
  profileImg: {
    height: '100px',
    width: '100px',
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  teacherLink: {
    fontSize: 14,
    padding: theme.spacing(),
    wordBreak: 'break-all',
  },
  smallIcon: {
    verticalAlign: 'text-bottom',
    color: 'black',
    height: 18,
    width: 18,
    marginRight: theme.spacing(),
  },
  extLinks: {
    color: 'black',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

class LocationPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      location: {},
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    // get class data
    getLocation(id)
      .then((response) => {
        console.log('got location: ', response.data);
        this.setState({
          location: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        // failed to load class
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to load location data.. please refresh the page',
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  render() {
    const { classes } = this.props;
    const {
      location,
      loading,
      snackbarVariant,
      snackbarMessage,
      snackbarOpen,
    } = this.state;

    console.log(location);

    function renderImg(location) {
      if (!location.user_img) {
        return profilePlaceholder;
      }
      return location.user_img;
    }

    function renderUsername(theuser) {
      if (!theuser.username) {
        return <Typography>User is set to private</Typography>;
      }
      return (
        <a className={classes.link} href={createProfileRoute(theuser.username)}>
          <Typography color="textSecondary">
            {theuser.first_name + ' ' + theuser.last_name}
          </Typography>
        </a>
      );
    }

    return (
      <div className={classes.page}>
        <NavBar />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <Typography className={classes.header} color="textSecondary" variant="h4">Location Details</Typography>


          <Paper className={classes.paper} elevation={1}>
            {loading
              ? <CircularProgress color="secondary" className={classes.loadingSpinner} />
              : (
                <Grid container>

                  <Helmet>
                    <title>{'Nia Classes at ' + location.title}</title>
                    <meta name="description" content={'Nia Teacher ' + location.user.first_name + ' ' + location.user.last_name + ' - ' + location.address} />
                  </Helmet>

                  {/* LOCATION IMAGE */}
                  <Grid item xs={12} sm={4} className={classes.gridPadding}>
                    <div
                      style={{ backgroundImage: location.img ? 'url("' + location.img + '")' : 'url("' + profilePlaceholder + '")' }}
                      className={classes.classImg}
                    />
                  </Grid>

                  {/* LOCATION NAME & ADDRESS */}
                  <Grid item xs={12} sm={8} className={classNames(classes.gridPadding, classes.headerContainer)}>
                    <Typography variant="h1" className={classes.classTypeHeader}>{location.title}</Typography>
                    <Typography variant="h2" color="textSecondary" className={classes.subHeader}>{location.address}</Typography>
                    <div className={classes.buttonContainer}>
                      <Button target="_blank" href={GOOGLE_MAPS_NAV_LINK + encodeURIComponent(location.address)} className={classes.button} variant="contained" color="secondary">Get Directions</Button>
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={12} sm={4} className={classNames(classes.borderRight, classes.gridPadding)}>
                    {/* USER */}
                    <div className={classNames(classes.sectionContent, classes.center)}>
                      <IconButton href={createProfileRoute(location.user.username)} className={classes.iconButton}>
                        <Avatar
                          className={classes.profileImg}
                          src={renderImg(location)}
                          title={location.user.first_name + ' ' + location.user.last_name}
                        />
                      </IconButton>
                      {renderUsername(location.user)}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.gridPadding}>
                    {/* CONTACT INFO */}
                    <Typography variant="h3" color="textSecondary" className={classes.h3}>Contact</Typography>
{/*                    {location.contact_name && (
                      <Typography className={classes.teacherLink}>{location.contact_name}</Typography>
                    )}*/}
                    {location.contact_email && (
                      <Typography className={classes.teacherLink}>
                        <EmailIcon className={classes.smallIcon} style={{ color: 'red' }} />
                        <a className={classes.extLinks} href={`mailto:${' ' + location.contact_email}?subject=Your Nia Location on NiaNow.com`}>{location.contact_email}</a>
                      </Typography>
                    )}
                    {location.contact_phone && ( // Comes from Contact Phone field on edit profile page
                      <Typography className={classes.teacherLink}>
                        <PhoneIcon className={classes.smallIcon} style={{ color: 'red' }} />
                        {location.contact_phone}
                      </Typography>
                    )}
                    {location.website && (
                      <Typography className={classes.teacherLink}>
                        <WebIcon className={classes.smallIcon} style={{ color: 'red' }} />
                        <a target="_blank" rel="noopener noreferrer" className={classes.extLinks} href={location.website}>Website</a>
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              )
            }
          </Paper>

          {/* SNACKBAR */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={snackbarOpen}
            autoHideDuration={5000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleClose}
              variant={snackbarVariant}
              message={snackbarMessage}
            />
          </Snackbar>
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

LocationPage.propTypes = {
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LocationPage);
